import { render, staticRenderFns } from "./ServiceBlock.vue?vue&type=template&id=391aee9e&scoped=true&lang=pug"
import script from "./ServiceBlock.vue?vue&type=script&lang=ts"
export * from "./ServiceBlock.vue?vue&type=script&lang=ts"
import style0 from "./ServiceBlock.vue?vue&type=style&index=0&id=391aee9e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391aee9e",
  null
  
)

export default component.exports